/**
 * Menu del telefono LeiDry (snippets/ldy-testa-cassetto.liquid), tendina a tutto schermo come il modello.
 * La X dentro la tendina chiude il cassetto di Horizon (<header-drawer>.close(), con la sua animazione).
 * Le tre voci (details) si aprono una alla volta.
 */
class LdyTestaCassetto extends HTMLElement {
  connectedCallback() {
    this.cassetto = this.closest('header-drawer');
    this.chiudi = this.querySelector('[data-ldy-chiudi]');
    this.alChiudi = this.alChiudi.bind(this);
    this.chiudi?.addEventListener('click', this.alChiudi);
    this.voci = [...this.querySelectorAll('.ldy-cassetto__voce')];
    this.voci.forEach((v) =>
      v.addEventListener('toggle', () => {
        if (!v.open) return;
        this.voci.forEach((altra) => {
          if (altra !== v) altra.open = false;
        });
      })
    );
  }

  disconnectedCallback() {
    this.chiudi?.removeEventListener('click', this.alChiudi);
  }

  alChiudi() {
    const drawer = /** @type {any} */ (this.cassetto);
    if (drawer && typeof drawer.close === 'function') drawer.close();
    else this.closest('details')?.removeAttribute('open');
  }
}

if (!customElements.get('ldy-testa-cassetto')) {
  customElements.define('ldy-testa-cassetto', LdyTestaCassetto);
}
